export enum CorporatePermissions {
  User = 1 << 0,
  Admin = 1 << 1,
}
